import { IProjectDeprecated, IPsetAndProperty } from "@mctypes/global.types";
import { IMCBIMAPI } from "@mctypes/mcbim.types";
import { ColDef, GetRowIdParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React from "react";
import { Button } from "@mantine/core";
import { AG_GRID_LOCALE_NOR } from "../../../agGridLocale";
import { McInputNew, McTextAreaNew, VSpace } from "../../../components";
import { doEnableMcBim, doGetActiveMcBimProjects } from "./systemAdminApi";

const McBimMasterAdmin: React.FC = () => {
  const [projects, setProjects] = React.useState<IProjectDeprecated[]>(null);
  const [addNewFormOpen, setAddNewFormOpen] = React.useState<boolean>(false);
  const [adminEmail, setAdminEmail] = React.useState<string>("");
  const [newProjectNo, setNewProjectNo] = React.useState<string>("");
  const [psetsFilter, setPsetsFilter] = React.useState<string>("");

  const [fileAttributeExtractSettings, setFileAttributeExtractSettings] =
    React.useState<IMCBIMAPI.AllFourFileAttributeExtracSettings>();

  const [pns, setPns] = React.useState<IPsetAndProperty>({
    pset: "",
    property: "",
  });

  const [defaultProp, setDefaultProp] = React.useState<IPsetAndProperty>({
    pset: "",
    property: "",
  });

  React.useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const _projects = await doGetActiveMcBimProjects();
    setProjects(_projects);
    setAdminEmail("");
    setNewProjectNo("");
    setAddNewFormOpen(false);
  };

  const columns = React.useMemo<ColDef<IProjectDeprecated>[]>(
    () => [
      {
        headerName: "Project nr",
        valueGetter: (params) => params.data?.maconomy?.projectNo,
        flex: 1,
        minWidth: 140,
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Project name",
        valueGetter: (params) => params.data?.maconomy?.name,
        flex: 2,
        minWidth: 240,
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Admins",
        valueGetter: (params) => params.data?.mcbim?.admins?.map((user) => user?.name).join(", "),
        flex: 2,
        minWidth: 240,
        filter: "agTextColumnFilter",
      },
    ],
    [],
  );

  const defaultColDef = React.useMemo<ColDef<IProjectDeprecated>>(
    () => ({
      sortable: true,
      resizable: true,
      suppressHeaderMenuButton: true,
    }),
    [],
  );

  const getRowId = React.useCallback((params: GetRowIdParams<IProjectDeprecated>) => params.data._id, []);

  const submit = async () => {
    try {
      const _psetsFilter = psetsFilter === "" ? [] : psetsFilter.split(",");
      const resp = await doEnableMcBim(
        newProjectNo,
        adminEmail,
        fileAttributeExtractSettings,
        _psetsFilter,
        pns,
        defaultProp,
      );
      init();
    } catch (error) {
      console.log(error);
      alert("failed. Check console");
    }
  };

  return (
    <div>
      Active MCBIM projekt
      {projects != null && (
        <div className="ag-theme-quartz w-100" style={{ height: "400px" }}>
          <AgGridReact<IProjectDeprecated>
            rowData={projects || []}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            getRowId={getRowId}
            headerHeight={35}
            animateRows={false}
            suppressContextMenu={true}
            localeText={AG_GRID_LOCALE_NOR}
          />
        </div>
      )}
      <Button onClick={() => setAddNewFormOpen(true)}>Add new</Button>
      {addNewFormOpen === true && (
        <div className="bg-light p-3">
          <McInputNew
            placeholder="Enter project no"
            style={{ width: "150px" }}
            value={newProjectNo}
            type="number"
            onChange={(e) => setNewProjectNo(e.target.value)}
          />
          <VSpace />
          <McInputNew
            placeholder="Enter admin email (short)"
            style={{ width: "150px" }}
            value={adminEmail}
            type="text"
            onChange={(e) => setAdminEmail(e.target.value)}
          />
          <VSpace />
          File attribute extract settings
          <McTextAreaNew
            placeholder="Enter file attribute extract settings"
            value={JSON.stringify(fileAttributeExtractSettings)}
            onChange={(e) => setFileAttributeExtractSettings(JSON.parse(e.target.value))}
          />
          <VSpace />
          PNS
          <McInputNew
            placeholder="PNS pset)"
            value={pns.pset}
            type="text"
            onChange={(e) => setPns({ ...pns, pset: e.target.value })}
          />
          <VSpace />
          <McInputNew
            placeholder="PNS prooperty)"
            value={pns.property}
            type="text"
            onChange={(e) => setPns({ ...pns, property: e.target.value })}
          />
          Defaut prop
          <McInputNew
            placeholder="pset)"
            value={defaultProp.pset}
            type="text"
            onChange={(e) => setDefaultProp({ ...defaultProp, pset: e.target.value })}
          />
          <VSpace />
          <McInputNew
            placeholder="property"
            value={defaultProp.property}
            type="text"
            onChange={(e) => setDefaultProp({ ...defaultProp, property: e.target.value })}
          />
          Psets
          <McInputNew
            placeholder="psets (comma separated)"
            value={psetsFilter}
            type="text"
            onChange={(e) => setPsetsFilter(e.target.value)}
          />
          <Button color="green" onClick={submit}>
            Send
          </Button>
        </div>
      )}
    </div>
  );
};

export default McBimMasterAdmin;
